import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Card from "@mui/material/Card";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import GoalPill from "layouts/goals/components/GoalPill";
import ChangePasswordForm from "./ChangePasswordForm";

function DetailRow({ label, children }) {
  return (
    <SuiBox display="flex" alignItems="center" py={1.25} gap={2}>
      <SuiTypography variant="caption" color="secondary" fontWeight="medium" sx={{ width: 90 }}>
        {label}
      </SuiTypography>
      {children}
    </SuiBox>
  );
}

// Every signed-in admin can open this page, whatever their role: it shows who
// you are and lets you change your own password.
function Profile() {
  const { admin, admin_teams_channels } = useSelector((state) => state.auth);

  const teamNames = useMemo(
    () => Array.from(new Set((admin_teams_channels || []).map((item) => item.team_name))),
    [admin_teams_channels]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox py={3}>
        <SuiTypography variant="h5" fontWeight="medium" mb={3}>
          Profile
        </SuiTypography>
        <Card sx={{ mb: 3 }}>
          <SuiBox p={3}>
            <SuiTypography variant="h6" fontWeight="medium" mb={1}>
              Account
            </SuiTypography>
            <DetailRow label="Name">
              <SuiTypography variant="button" fontWeight="medium">
                {admin?.name}
              </SuiTypography>
            </DetailRow>
            <DetailRow label="Email">
              <SuiTypography variant="button" fontWeight="regular">
                {admin?.email}
              </SuiTypography>
            </DetailRow>
            <DetailRow label="Role">
              {admin?.role ? <GoalPill color="info">{admin.role.name}</GoalPill> : "—"}
            </DetailRow>
            <DetailRow label="Teams">
              <SuiTypography variant="button" fontWeight="regular">
                {teamNames.join(", ") || "—"}
              </SuiTypography>
            </DetailRow>
          </SuiBox>
        </Card>
        <Card>
          <SuiBox p={3}>
            <SuiTypography variant="h6" fontWeight="medium" mb={0.5}>
              Change password
            </SuiTypography>
            <SuiTypography variant="caption" color="text" display="block" mb={3}>
              Changing your password signs you out of all your other devices.
            </SuiTypography>
            <ChangePasswordForm />
          </SuiBox>
        </Card>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Profile;
